package org.matthewo.schema

import org.matthewo.symbolprocessor.Metric
import org.matthewo.symbolprocessor.Period
import kotlin.reflect.KProperty1

interface StandardMetrics<out T : Number> {
    @Metric(Period.ALL, "Total")
    val total: T

    @Metric(Period.ALL, "NP Total")
    val npTotal: T

    @Metric(Period.AUTO, "Auto")
    val auto: T

    @Metric(Period.TELEOP, "Teleop")
    val teleop: T

    @Metric(Period.ENDGAME, "Endgame")
    val endgame: T

    @Metric(Period.ALL, "Penalty")
    val penalty: T
}

interface RankingMetrics<out T : Number> {
    val tbp1: T
}

interface StandardRankingMetrics<out T : Number> : StandardMetrics<T>, RankingMetrics<T>

interface MutableStandardMetrics<T : Number> : StandardMetrics<T> {
    override var total: T
    override var npTotal: T
    override var auto: T
    override var teleop: T
    override var endgame: T
    override var penalty: T
}

interface LocalMetrics<T, N : Number> : MutableStandardMetrics<N> {
    val competition: T
}

inline fun <reified T> MutableStandardMetrics<*>.localOrNull(): LocalMetrics<T, *>? {
    if (this !is LocalMetrics<*, *>) return null
    if (competition !is T) return null
    @Suppress("UNCHECKED_CAST")
    return this as LocalMetrics<T, *>
}

interface MetricsMeta<M : StandardMetrics<*>> {
    val names: Map<KProperty1<M, Number>, String>
    val periods: Map<KProperty1<M, Number>, Period>
}

// TODO: yikes?
@Suppress("UNCHECKED_CAST")
fun <N : Number, M : StandardMetrics<N>> MetricsMeta<in M>.names() =
    names as Map<KProperty1<M, N>, String>

@Suppress("UNCHECKED_CAST")
fun <N : Number, M : StandardMetrics<N>> MetricsMeta<in M>.periods() =
    periods as Map<KProperty1<M, N>, Period>

// TODO: YIKES!
@Suppress("UNCHECKED_CAST")
fun <N : Number, M : StandardMetrics<N>> MetricsMeta<*>.namesUnsafe() =
    names as Map<KProperty1<M, N>, String>

@Suppress("UNCHECKED_CAST")
fun <N : Number, M : StandardMetrics<N>> MetricsMeta<*>.periodsUnsafe() =
    periods as Map<KProperty1<M, N>, Period>
